export default {"src":"/_next/static/media/pill_64.b60fbfd7.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};